import * as React from 'react'
import List from '@mui/material/List'
import ListItem from '@mui/material/ListItem'
import ListItemButton from '@mui/material/ListItemButton'
import ListItemText from '@mui/material/ListItemText'
import { Grid, ListItemIcon, ListSubheader } from '@mui/material'
import DeletePrice from './DeletePrice'
import EditPrice from './EditPrice'
import PriceIcon from '@mui/icons-material/Euro'
import schema from '../../schemas/price.json'
import { JSONSchema7 } from 'json-schema'
import { Price } from '../../interfaces/price'
import CreatePrice from './CreatePrice'

export interface Props {
  disabled: boolean
  data: Price[]
  setData: React.Dispatch<React.SetStateAction<any[]>>
}

export default function PriceList({ disabled, data, setData }: Props) {
  return (
    <List
      dense
      subheader={
        <ListSubheader>
          <Grid container alignItems={'center'}>
            {'Price'}
            <CreatePrice
              disabled={disabled || (data && data.length > 0)}
              data={data}
              schema={schema as JSONSchema7}
              setData={setData}
            />
          </Grid>
        </ListSubheader>
      }
    >
      {data.map((obj: Price, index: number) => {
        return (
          <ListItem
            key={index}
            secondaryAction={
              <>
                <EditPrice disabled={disabled} schema={schema as JSONSchema7} value={obj} setData={setData} />
                <DeletePrice disabled={disabled} value={obj} setData={setData} />
              </>
            }
            disablePadding
          >
            <ListItemButton disabled={disabled}>
              <ListItemIcon>
                <PriceIcon />
              </ListItemIcon>
              <ListItemText
                primary={obj.name}
                secondary={`solar cost: ${obj.solar_cost} €/W | battery cost: ${obj.battery_cost} €/kWh`}
                sx={{ '.MuiListItemText-secondary': { display: { xs: 'none', sm: 'block' } } }}
              />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )
}
